import React, { Fragment } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, Container } from "reactstrap"
import { Filter, DefaultColumnFilter } from "./filters"
import Breadcrumbs from "../../components/Common/Breadcrumb"

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const count = preGlobalFilteredRows.length
  const [value, setValue] = React.useState(globalFilter)
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
  }, 200)

  return (
    <Col sm={4}>
      <div className="search-box me-2 mb-2 d-inline-block">
        <div className="position-relative">
          <label htmlFor="search-bar-0" className="search-label">
            <span id="search-bar-0-label" className="sr-only">
              Search this table
            </span>
            <input
              onChange={e => {
                setValue(e.target.value)
                onChange(e.target.value)
              }}
              id="search-bar-0"
              type="text"
              className="form-control"
              placeholder={`${count} records...`}
              value={value || ""}
            />
          </label>
          <i className="bx bx-search-alt search-icon"></i>
        </div>
      </div>
    </Col>
  )
}

const TableContainer = ({
  columns,
  data,
  isGlobalFilter,
  isAddOptions,
  isAddUserList,
  handleOrderClicks,
  handleUserClick,
  handleaEditAccordian,
  handleEditTeamAccordian,
  handleEditGroup,
  handleCustomerClick,
  isAddCustList,
  customPageSize,
  customPageSizeOptions,
  isaccordian,
  buttonName,
  isaccordianTeam,
  hidepagination,
  setshowUserTable,
  setaccordionSelectedData,
  setselectedid,
  selectedid,
  selectIndex,
  handleAddUser,
  isCategory,
  selectedRow,
  setTableUserdata,
  TableuserData,
  handleUserCancel,
  userModel,
  usertoggle,
  handleUserEdit,
  setTableScategorydata,
  TableScategoryData,
  isEdit,
  buttonNameSub,
  breadcrumName,
  handleAddSub,
  handleSubEdit,
  subModel,
  subtoggle,
  isAddSubList,
  companySetting,
  pageindex,
  totalCount,
  handlePageValue,
  hideMainCategorybutton,
  hideSubCategorybutton,
  catgegoryWidthControl,
  isCategorySearch,
  accessgroupname,
  hideaccessgroupsetting,
  handleaccessEditGroup,
  isAddAccessList,
  setSearchcategory,
  Searchcategory,
  MainCategoryName,
  SubCategoryName,
  setSearchSubCategory,
  SearchSubCategory,
  handleSubmit,
  setemptySearchField,
  setselectedUserRow,
  setCategoryUserModal,
  setselectedindex,
  selectedSubCategory,
  selectedUserCategory,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,

    state: { pageIndex, pageSize, expanded },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        // expanded: { '0': true , '2': true},
        // expanded: !isEmpty(objindex) ? objindex  : { "": true },
        pageIndex: pageindex,
        pageSize: customPageSize,
        hiddenColumns:
          hideaccessgroupsetting == false ? ["hideeditButton"] : [],
      },
      manualPagination: true,
      pageCount: Math.ceil(totalCount / customPageSize),
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )
  const generateSortingIndicator = column => {
    return column.sort == true? <i className={column.isSortedDesc ? "bx bx-sort-down" : "bx bx-sort-up"}></i> : ""
  }

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
    handlePageValue({
      pageSize: Number(event.target.value),
      pageNumber: 0,
      // noChange: true,
    })
  }

  const getSelectedRowwValues = selectedRow => {
    if (isCategory) {
      handleUserEdit({ ...selectedRow.original })
    }
    if (isAddSubList) {
      handleSubEdit({ ...selectedRow.original })
    }
    if (isAddUserList || isCategorySearch) {
      handleEditGroup({ ...selectedRow.original })
    }
    if (isaccordian) {
      handleaEditAccordian({ ...selectedRow.original })
    }
    if (hideaccessgroupsetting == true && isAddAccessList) {
      handleaccessEditGroup({ ...selectedRow.original })
    }

    if (!isaccordianTeam) {
      // handleEditGroup({ ...selectedRow.original })
    } else {
      setshowUserTable(true)
      setselectedid(selectedRow.id)
      setaccordionSelectedData(selectedRow.original)
    }
  }

  const handlenext = data => {
    nextPage(data)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: pageIndex + 1,
    })
  }
  const handleprev = () => {
    previousPage()
    handlePageValue({
      pageSize: pageSize,
      pageNumber: pageIndex - 1,
    })
  }
  const handlestartpage = () => {
    gotoPage(0)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: 0,
    })
  }
  const handlelastpage = () => {
    gotoPage(pageCount - 1)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: Math.ceil(totalCount / pageSize) - 1,
    })
  }
  const onChangeInInput = event => {
    if (pageCount - 1 >= event.target.value) {
      const page = event.target.value > 0 ? Number(event.target.value) - 1 : 0
      gotoPage(page)
      handlePageValue({
        pageSize: pageSize,
        pageNumber: page,
      })
    }
  }

  return (
    <Fragment>
      {/* <Row className="mb-2"> */}
      <Row className={isCategorySearch ? "mobile_wrap_bottom mb-2" : "mb-2"}>
        {isGlobalFilter && (
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
          />
        )}
        {isAddOptions && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded  mb-2 me-2"
                onClick={handleOrderClicks}
              >
                <i className="mdi mdi-plus me-1" />
                Add New Order
              </Button>
            </div>
          </Col>
        )}

        {isAddUserList && hideMainCategorybutton && (
          <Col>
            <div className="text-sm-end ">
              <Button
                type="button"
                color="primary"
                className="btn mb-2 me-2"
                onClick={handleUserClick}
              >
                <i className="mdi mdi-plus-circle-outline me-1" />
                {buttonName}
              </Button>
            </div>
          </Col>
        )}
        {isCategory && hideMainCategorybutton && (
          <div className="d-flex align-items-center breadcrumbtitle">
            <Breadcrumbs title="User Table" breadcrumbItem="User List" />

            <Col>
              <div className="text-sm-end ">
                <Button
                  type="button"
                  color="primary"
                  className="btn mb-2 me-2"
                  onClick={handleAddUser}
                >
                  <i className="mdi mdi-plus-circle-outline me-1" />
                  {buttonName}
                </Button>
              </div>
            </Col>
          </div>
        )}
        {isAddSubList && hideSubCategorybutton && (
          <div className="d-flex align-items-center breadcrumbtitle">
            <Breadcrumbs
              title="Sub_Category"
              breadcrumbItem={`${breadcrumName} List`}
            />
            <Col>
              <div className="text-sm-end ">
                <Button
                  type="button"
                  color="primary"
                  className="btn mb-2 me-2"
                  onClick={handleAddSub}
                >
                  <i className="mdi mdi-plus-circle-outline me-1" />
                  {buttonNameSub}
                </Button>
              </div>
            </Col>
          </div>
        )}
        {isAddCustList && (
          <Col sm="7">
            <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={handleCustomerClick}
              >
                <i className="mdi mdi-plus me-1" />
                New Customers
              </Button>
            </div>
          </Col>
        )}
      </Row>

      <div
        className="table-responsive react-table"
        style={
          isCategory && {
            overflowX: "inherit",
          }
        }
      >
        <Table bordered hover {...getTableProps()}>
          <thead className="table-light table-center">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th key={column.id}>
                    <div
                      // className="mb-2"
                      className={`mb-2 ${catgegoryWidthControl && "align_widthControl"
                        }`}
                      {...column.getSortByToggleProps({
                        style: {
                          minWidth: column.minWidth,
                          width: column.width,
                        },
                      })}
                    >
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                    <Filter column={column} />
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {(page.length > 0 &&
              page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr
                      className={
                        isaccordianTeam && selectedid == row.id
                          ? "selectedRow"
                          : ""
                      }
                      style={{ cursor: "pointer" }}
                      {...row.getRowProps()}
                      onClick={e => {
                        {
                          buttonName === "Create Access Group"
                            ? accessgroupname === "Admin" &&
                            (e.target.cellIndex ||
                              e.target.cellIndex === 0) &&
                            getSelectedRowwValues(row)
                            : (e.target.cellIndex ||
                              e.target.cellIndex === 0) &&
                            getSelectedRowwValues(row)
                        }
                      }}
                    >
                      {row.cells.map(cell => {
                        return (
                          // data-label should be no horizantal scroll and mobile responsive then add this class nameis "table-mobileView"
                          <td key={cell.id} {...cell.getCellProps()}  data-label={cell?.column?.Header}>
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  </Fragment>
                )
              })) || (
                <tr>
                  <td
                    colSpan={"6"}
                    className="react-bs-table-no-data text-center"
                  >
                    Sorry, There are no data to display
                  </td>
                </tr>
              )}
          </tbody>
        </Table>
      </div>
      {isaccordian && (
        <Col>
          <div className="text-sm-end ">
            <Button
              type="button"
              color="primary"
              className="btn mb-2 me-2"
              onClick={handleaEditAccordian}
            >
              {buttonName}
            </Button>
          </div>
        </Col>
      )}

      {page.length > 0 ? (
        <>
          {!hidepagination && (
            <div className="pagination justify-content-end customiz_pagination">
              <Col sm={customPageSizeOptions ? 2 : 1} className="me-3 p-2">
                <select
                  className="form-select p-1"
                  value={pageSize}
                  onChange={onChangeInSelect}
                >
                  {[10, 20, 30, 40, 50].map(pageSize => (
                    <option key={pageSize} value={pageSize}>
                      Show {pageSize}
                    </option>
                  ))}
                </select>
              </Col>

              <div className="paginations d-flex justify-content-end align-items-center">
                <Container>
                  <Row className=" align-items-center">
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="primary"
                          onClick={handlestartpage}
                          disabled={!canPreviousPage}
                        >
                          {"<<"}
                        </Button>{" "}
                        <Button
                          color="primary"
                          onClick={handleprev}
                          disabled={!canPreviousPage}
                        >
                          {"<"}
                        </Button>{" "}
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      <span>
                        Page{" "}
                        <strong>
                          {pageindex + 1} of {Math.ceil(totalCount / pageSize)}
                        </strong>{" "}
                      </span>
                    </Col>
                    <Col className="col-md-auto">
                      <span className="show_desptop">
                        | Go to page:{"    "}
                        <input
                          type="number"
                          value={pageindex + 1}
                          onChange={onChangeInInput}
                          style={{ width: "50px", textAlign: "center" }}
                        />
                      </span>
                      <span className="show_desptop">
                        Go to page:{"    "}
                        <input
                          type="number"
                          value={pageindex + 1}
                          onChange={onChangeInInput}
                          style={{ width: "50px", textAlign: "center" }}
                        />
                      </span>
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="primary"
                          onClick={handlenext}
                          disabled={
                            !canNextPage ||
                            pageIndex >= Math.ceil(totalCount / pageSize) - 1
                          }
                        >
                          {">"}
                        </Button>{" "}
                        <Button
                          color="primary"
                          onClick={handlelastpage}
                          disabled={
                            !canNextPage ||
                            pageIndex >= Math.ceil(totalCount / pageSize) - 1
                          }
                        >
                          {">>"}
                        </Button>{" "}
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          )}
        </>
      ) : (
        ""
      )}
    </Fragment>
  )
}

TableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default TableContainer
